import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names, resolving conflicts in favour of the last value.
 *
 * Every component in this package takes a `className` prop and passes it through
 * `cn`, so a caller can always override a default without specificity battles.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
